import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Eye, Link } from 'lucide-react';

interface FeatureComparisonHeaderProps {
  onToggleAll: () => void;
  allExpanded: boolean;
}

const FeatureComparisonHeader = ({ onToggleAll, allExpanded }: FeatureComparisonHeaderProps) => {
  return (
    <div className="text-center mb-8">
      <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
        Compare All Features
      </h2>
      <p className="text-base text-muted-foreground max-w-xl mx-auto mb-4">
        See exactly what's included in each plan to make the best choice for your needs
      </p>
      
      
      <Button
        variant="outline"
        size="sm"
        onClick={onToggleAll}
        className="text-xs">

        {allExpanded ? 'Collapse All' : 'Expand All'}
      </Button>
    </div>);

};

export default FeatureComparisonHeader;